function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    background-color: ", ";\n    border-radius: 4px;\n    box-sizing: border-box;\n    color: ", ";\n    padding: ", ";\n    width: 396px;\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import React, { createRef } from "react";
import styled, { css } from "styled-components";
import { Popover } from "@diana-ui/popover";
var MenuWrapper = styled.div((_ref) => {
  var {
    theme
  } = _ref;
  return css(_templateObject(), theme.colors.blue.blue100, theme.colors.white, theme.spaceUnit.lg);
});

var Menu = (_ref2) => {
  var {
    children
  } = _ref2,
      props = _objectWithoutProperties(_ref2, ["children"]);

  var ref = /*#__PURE__*/createRef();
  return /*#__PURE__*/React.createElement(Popover, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(MenuWrapper, null, React.Children.map(children, child => /*#__PURE__*/React.cloneElement(child, {
    ref
  }))));
};

export default Menu;